<script setup lang="ts">
import MainBanner from '@/assets/pngs/main_banner.png'
import { useIsMobile } from '@/composables/useMediaQuery'
import { useAuthStore } from '@/stores/auth'
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

// 프로그램 이미지 import
import program01 from '@/assets/pngs/programs/program_01.png'
import program02 from '@/assets/pngs/programs/program_02.png'
import program03 from '@/assets/pngs/programs/program_03.png'
import program04 from '@/assets/pngs/programs/program_04.png'
import program05 from '@/assets/pngs/programs/program_05.png'
import program06 from '@/assets/pngs/programs/program_06.png'
import program07 from '@/assets/pngs/programs/program_07.png'
import program08 from '@/assets/pngs/programs/program_08.png'
import program09 from '@/assets/pngs/programs/program_09.jpg'
import program10 from '@/assets/pngs/programs/program_10.jpg'
import program11 from '@/assets/pngs/programs/program_11.jpg'
import program12 from '@/assets/pngs/programs/program_12.jpg'
import program13 from '@/assets/pngs/programs/program_13.jpg'
import program14 from '@/assets/pngs/programs/program_14.jpg'
import program15 from '@/assets/pngs/programs/program_15.jpg'
import program16 from '@/assets/pngs/programs/program_16.jpg'

// 플레이어 기능 이미지 import
import player01 from '@/assets/pngs/player/player_feature_01.png'
import player02 from '@/assets/pngs/player/player_feature_02.png'
import player03 from '@/assets/pngs/player/player_feature_03.png'
import player04 from '@/assets/pngs/player/player_feature_04.png'

// 플레이어 아이콘 import
import arOnYou from '@/assets/svgs/player/ar_on_you.svg'
import arOnYouGray from '@/assets/svgs/player/ar_on_you_gray.svg'
import formatListBulleted from '@/assets/svgs/player/format_list_bulleted.svg'
import formatListBulletedGray from '@/assets/svgs/player/format_list_bulleted_gray.svg'
import repeat from '@/assets/svgs/player/repeat.svg'
import repeatGray from '@/assets/svgs/player/repeat_gray.svg'

const router = useRouter()
const isMobile = useIsMobile()
const authStore = useAuthStore()

const programs = ref([
  { title: '에어로빅 댄스', imageSrc: program01 },
  { title: '댄스 휘트니스', imageSrc: program02 },
  { title: '스텝', imageSrc: program03 },
  { title: '태보', imageSrc: program04 },
  { title: '에어로빅 홈트레이닝', imageSrc: program05 },
  { title: '에어로빅 생활스포츠지도사 준비반', imageSrc: program06 },
  { title: '에어로빅 지도자 자격증반', imageSrc: program07 },
  { title: '에어로빅 짐내스틱 트레이닝', imageSrc: program08 },
  { title: '힙합댄스 (휘트니스)', imageSrc: program09 },
  { title: '힙합 노비스', imageSrc: program10 },
  { title: '힙합 (스트릿)', imageSrc: program11 },
  { title: '락킹 (스트릿)', imageSrc: program12 },
  { title: '비보이 (스트릿)', imageSrc: program13 },
  { title: '팝핀 (스트릿)', imageSrc: program14 },
  { title: '힙합댄스 (어드밴스 레벨)', imageSrc: program15 },
  { title: 'K-POP', imageSrc: program16 },
])

const infoCards = ref([
  {
    title: '대시보드',
    description:
      '사용자 개개인 별로 수업 진척도부터\n추천 강좌를 확인할 수 있습니다.\n다양한 커리큘럼을 체계적으로 경험하세요.',
    isGradient: true,
  },
  {
    title: '오픈 클래스',
    description:
      '한국 에어로빅에 대한 모든 새로운 소식이\n이곳에 업데이트됩니다.\n다양한 대회, 행사, 정보들을 오픈 클래스에서 확인하세요.',
    isGradient: false,
  },
  {
    title: '라이브 스트리밍',
    description:
      '한국 에어로빅의 각종 대회, 행사 등을\n라이브 스트리밍으로 만나보실 수 있습니다.\n실시간 비대면으로 프렌드에서 여러 행사를 확인하세요.',
    isGradient: false,
  },
  {
    title: '온라인 수업',
    description:
      '여러분의 점진적인 실력 향상을 위해\n프렌드에서 온라인 수업을 제공합니다.\n매주 진행되는 에어로빅 온라인 수업을 프렌드에서 경험하세요.',
    isGradient: false,
  },
])

const controls = ref([
  {
    title: '영상 배속 선택',
    icon: formatListBulleted,
    grayIcon: formatListBulletedGray,
    imageSrc: player01,
  },
  {
    title: '내 카메라 켜기',
    icon: arOnYou,
    grayIcon: arOnYouGray,
    imageSrc: player02,
  },
  {
    title: '구간 반복',
    icon: repeat,
    grayIcon: repeatGray,
    imageSrc: player03,
  },
  {
    title: '강좌 챕터보기',
    icon: formatListBulleted,
    grayIcon: formatListBulletedGray,
    imageSrc: player04,
  },
])

const onlineClassDescription = computed(() => {
  return isMobile.value
    ? '여러분의 점진적인 실력 향상을 위해\n프렌드에서 온라인 수업을 제공합니다.\n매주 진행되는 에어로빅 온라인 수업을\n프렌드에서 경험하세요.'
    : '여러분의 점진적인 실력 향상을 위해\n프렌드에서 온라인 수업을 제공합니다.\n매주 진행되는 에어로빅 온라인 수업을 프렌드에서 경험하세요.'
})

const handleStartButtonClick = () => {
  router.push('/login')
}

const selectedControl = ref(controls.value[0])

const handleControlButtonClick = (control: (typeof controls.value)[0]) => {
  selectedControl.value = control
}

const bannerTitle = computed(() => {
  return isMobile.value ? 'FRIEND ACADEMY' : 'FRIEND\nACADEMY'
})

const bannerDescription = computed(() => {
  return isMobile.value
    ? `1000+ 온라인 수업, 체계적인 프로그램과\n클래스를 통해 여러분의 목표에 도전하세요.`
    : `1000+ 온라인 수업,\n체계적인 프로그램과 클래스를 통해\n여러분의 목표에 도전하세요.`
})

onMounted(async () => {
  if (authStore.state.refreshToken) {
    await authStore.getAccessToken()
    await authStore.getUserInfo()
    if (authStore.isAuthenticated) {
      router.push('/dashboard')
    }
  }
})

const footerInfo = computed(() => {
  return isMobile.value
    ? `법인명 : (주)한빛 I 대표자 : 김형기<br/>고객센터 : 043-851-1114<br/>등록번호 : 303-81-60565 <a
            class="footer-link sub-md gray-200"
            href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=3038160565"
            target="_blank"
            >링크</a
          ><br/>통신판매업 신고번호 : 제 2021-충북충주-0070 호<br/>주소 : 충청북도 충주시 중앙탑면\n첨단산업로 1315(2층)`
    : `법인명 : (주)한빛 I 대표자 : 김형기 I 고객센터 : 043-851-1114 I 등록번호 : 303-81-60565
          <a
            class="footer-link body-sm gray-200"
            href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=3038160565"
            target="_blank"
            >링크</a
          >
          <br />통신판매업 신고번호 : 제 2021-충북충주-0070 호 I 주소 : 충청북도 충주시 중앙탑면
          첨단산업로 1315(2층)`
})
</script>

<template>
  <div class="home-container">
    <!-- 메인 배너 섹션 -->
    <section class="main-banner">
      <img class="banner-image" :src="MainBanner" alt="메인 배너" />
      <div class="banner-overlay">
        <h2 class="banner-subtitle">에어로빅의 모든것</h2>
        <h1 class="banner-title">{{ bannerTitle }}</h1>
        <p class="banner-description">{{ bannerDescription }}</p>
        <button @click="handleStartButtonClick" class="start-button">시작하기</button>
      </div>
    </section>

    <!-- 프로그램 섹션 -->
    <section class="programs-section">
      <h2 class="section-title">다양한 커리큘럼의 에어로빅 프로그램</h2>
      <div class="program-grid">
        <div v-for="(program, index) in programs" :key="index" class="program-card">
          <img :src="program.imageSrc" :alt="program.title" class="program-image" />
          <div class="program-title">{{ program.title }}</div>
        </div>
      </div>
    </section>

    <!-- 플레이어 기능 섹션 -->
    <section class="player-features">
      <h2 class="section-title black">연습에 최적화된 플레이어 기능</h2>
      <img class="player-preview" :src="selectedControl.imageSrc" alt="플레이어 미리보기" />
      <div class="player-controls">
        <div
          v-for="(control, index) in controls"
          :key="index"
          class="control-button"
          :class="{ selected: selectedControl === control }"
          @click="handleControlButtonClick(control)"
        >
          <img
            :src="selectedControl === control ? control.icon : control.grayIcon"
            :alt="control.title"
            class="control-icon"
          />
          <span class="control-text">{{ control.title }}</span>
        </div>
      </div>
    </section>

    <!-- 정보 섹션 -->
    <section class="info-section">
      <h2 class="section-title">한국 에어로빅의 모든 최신 정보</h2>
      <div class="info-grid">
        <div v-for="(info, index) in infoCards" :key="index" class="info-card">
          <h3 class="info-title">{{ info.title }}</h3>
          <p v-if="info.title === '온라인 수업'" class="info-description">
            {{ onlineClassDescription }}
          </p>
          <p v-else class="info-description">{{ info.description }}</p>
        </div>
      </div>
    </section>

    <!-- 푸터 -->
    <footer class="footer">
      <div class="footer-content">
        <img class="footer-logo" src="@/assets/pngs/friend_footer_logo.png" alt="logo" />
        <div class="footer-terms-and-privacy body-md white" :class="{ 'body-sm': isMobile }">
          <div class="cursor-pointer" @click="router.push('/use-terms')">이용약관</div>
          <div class="cursor-pointer" @click="router.push('/privacy-terms')">개인정보처리방침</div>
          <div class="cursor-pointer">고객센터</div>
        </div>
        <div
          class="footer-info body-sm gray-200"
          :class="{ 'sub-md': isMobile }"
          v-html="footerInfo"
        ></div>
      </div>
    </footer>
  </div>
</template>

<style scoped>
.home-container {
  width: 100%;
  min-height: calc(100vh - 100px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.header-background {
  width: 100%;
  height: 100%;
  background: white;
}

.login-text {
  position: absolute;
  right: 123px;
  top: 38px;
  text-align: right;
  color: #212121;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 24px;
}

.logo {
  width: 191px;
  height: 73.48px;
  position: absolute;
  left: 865px;
  top: 13px;
}

/* 메인 배너 스타일 */
.main-banner {
  width: 100%;
  height: 1080px;
  aspect-ratio: 16 / 9;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0;
}

.banner-image {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.banner-overlay {
  width: 800px;
  height: 920px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 20px;
  padding: 80px 40px;
  position: absolute;
  right: 40px;
  top: 80px;
}

.banner-subtitle {
  color: white;
  font-size: 66px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 92.4px;
  margin-bottom: 12px;
}

.banner-title {
  color: white;
  font-size: 108px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 116.64px;
  margin-bottom: 40px;
}

.banner-description {
  color: white;
  font-size: 36px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 54px;
  margin-bottom: 140px;
  white-space: pre-line;
}

.start-button {
  width: 720px;
  height: 100px;
  background: linear-gradient(135deg, #e34c46 0%, #b12d73 100%);
  border-radius: 8px;
  border: none;
  color: white;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 700;
  cursor: pointer;
}

/* 프로그램 섹션 스타일 */
.programs-section {
  background: #212121;
  padding: 140px 0;
}

.section-title {
  width: 1280px;
  margin: 0 auto;
  color: white;
  font-size: 64px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 83.2px;
  margin-bottom: 40px;
}

.section-title.black {
  color: #212121;
}

.program-grid {
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 413px);
  column-gap: 20px;
  row-gap: 40px;
}

.program-card {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 24px;
}

.program-image {
  width: 100%;
  height: 232px;
  border-radius: 8px;
  background: #dde5ea;
  object-fit: cover;
}

.program-title {
  color: white;
  font-size: 28px;
  font-family: Pretendard;
  font-weight: 700;
  text-align: center;
  position: static;
  transform: none;
  bottom: auto;
  left: auto;
}

/* 플레이어 기능 섹션 스타일 */
.player-features {
  padding: 140px 0;
}

.player-preview {
  width: 100%;
  max-width: 1280px;
  height: auto;
  aspect-ratio: 16/9;
  margin: 40px auto;
  display: block;
}

.player-controls {
  display: flex;
  justify-content: center;
  gap: 25px;
  margin-top: 40px;
}

.control-button {
  width: 300px;
  height: 180px;
  background: #eff2f3;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.control-button.selected {
  background: linear-gradient(135deg, #e34c46 0%, #b12d73 100%);
  color: white;
}

.control-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 14px;
}

.control-text {
  font-size: 28px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 130%;
  letter-spacing: 0px;
}

/* 정보 섹션 스타일 */
.info-section {
  background: #212121;
  padding: 140px 0;
}

.info-grid {
  max-width: 1280px;
  margin: 40px auto;
  display: grid;
  grid-template-columns: repeat(2, 630px);
  column-gap: 20px;
  row-gap: 20px;
}

.info-card {
  height: 300px;
  border-radius: 8px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 3px solid transparent;
  background:
    linear-gradient(#212121, #212121) padding-box,
    linear-gradient(135deg, #e34c46 0%, #b12d73 100%) border-box;
}

.info-title {
  color: white;
  font-size: 36px;
  font-family: Pretendard;
  font-weight: 700;
  margin-bottom: 20px;
}

.info-description {
  color: white;
  font-size: 20px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 26px;
  white-space: pre-line;
}

/* 푸터 스타일 */
.footer {
  width: 100%;
  height: auto;
  padding: 36px 0 70px 0;
  background: #2e3032;
  margin: 0 auto;
}

.footer-content {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: start;
}

.footer-logo {
  width: 185px;
  height: 100px;
  margin-bottom: 24px;
}

.footer-terms-and-privacy {
  display: flex;
  flex-direction: row;
  gap: 40px;
  margin-bottom: 24px;
}

@media screen and (max-width: 1365px) {
  .home-container {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  }

  .main-banner {
    width: 100%;
    max-width: 600px;
    height: auto;
    aspect-ratio: unset;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 0;
    margin: 0;
    position: relative;
  }
  .banner-image {
    width: 100%;
    height: auto;
    aspect-ratio: 16/9;
    height: auto;
    object-fit: cover;
    display: block;
    position: static;
  }
  .banner-overlay {
    position: static;
    width: 100%;
    height: auto;
    background: #fff;
    color: #212121;
    border-radius: 0px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    padding: 16px 20px 52px 20px;
    text-align: center;
    z-index: 2;
  }
  .banner-subtitle {
    color: var(--gray-900, #212121);
    text-align: center;
    /* S_Title */
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%; /* 25.2px */
    margin-bottom: 6px;
  }
  .banner-title {
    color: var(--gray-900, #212121);
    text-align: center;

    /* M_Title */
    font-family: Pretendard;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%; /* 39.2px */
    margin-bottom: 8px;
  }

  .banner-description {
    color: var(--gray-800, #3f4147);
    text-align: center;

    /* M_Body */
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 24px */
    margin-bottom: 32px;
  }
  .start-button {
    width: 100%;
    height: 56px;
    border-radius: 8px;
    background: linear-gradient(135deg, #e34c46 0%, #b12d73 100%);
    color: var(--gray-000, #fff);
    text-align: center;

    /* M_Body */
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 24px */
  }

  .section-title {
    width: 100%;
    max-width: 100vw;

    color: var(--gray-000, #fff);
    text-align: center;

    /* S_Title */
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%; /* 25.2px */
    margin-bottom: 12px;
  }
  .programs-section,
  .info-section,
  .player-features {
    padding: 60px 0;
    margin: 0;
  }

  .programs-section {
    align-items: center;
    justify-content: center;
  }

  .program-grid {
    display: flex;
    flex-direction: row;
    gap: 16px;
    max-width: 100vw;
    margin: 16px 0 32px 0;
    padding: 0 16px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
  }
  .program-grid::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
  .info-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 100vw;
    margin: 20px 0 32px 0;
    padding: 0 16px;
  }
  .program-card,
  .info-card {
    width: 100%;
    min-width: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .program-card {
    min-width: 178px;
    max-width: 178px;
    min-height: 133px;
    max-height: 133px;
    flex: 0 0 auto;
    gap: 12px;
  }
  .program-image {
    min-width: 178px;
    max-width: 178px;
    min-height: 100px;
    max-height: 100px;
  }
  .program-title {
    color: var(--gray-000, #fff);
    text-align: center;

    /* S_Body */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
  }
  .player-preview {
    width: 100%;
    max-width: 100%;
    height: auto;
    aspect-ratio: 16/9;
    margin: 0 0 12px 0;
    padding: 0 20px;
    display: block;
  }
  .player-controls {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 7px;
    padding: 0 20px 0 20px;
    margin-top: 12px;
  }
  .control-button {
    width: 100%;
    height: 80px;
  }
  .control-icon {
    width: 24px;
    height: 24px;
    margin-bottom: 4px;
  }
  .control-text {
    text-align: center;

    /* L_Body */
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 24px */
  }
  .info-card {
    padding: 28px 12px;
    height: auto;
  }
  .info-title {
    color: var(--gray-000, #fff);
    text-align: center;

    /* L_Body */
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 24px */
    margin-bottom: 8px;
  }
  .info-description {
    color: var(--gray-000, #fff);
    text-align: center;

    /* S_Body */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
  }

  .footer {
    width: 100%;
    height: auto;
    padding: 40px 20px;
    background: #2e3032;
    margin-top: 0px;
  }

  .footer-logo {
    width: 74px;
    height: 40px;
    margin-bottom: 16px;
  }

  .footer-terms-and-privacy {
    gap: 20px;
    margin-bottom: 22px;
  }

  .footer-info {
    margin-top: 16px;
  }
}
</style>
